import { render } from "./EditModel3d.vue?vue&type=template&id=159e8974&scoped=true"
const script = {}

import "./EditModel3d.vue?vue&type=style&index=0&id=159e8974&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-159e8974"]])

export default __exports__